import { Project } from "../types/create-project";
import { clients } from "../../../lib/https"
import { ConfigurationSettings } from "/models/configuration-settings"


// interface ProjectResponse {
//     Id: string;
//     Name: string;
//     Exttra: Record<string, unknown>;
//     Conversations: any[];
// }

export interface getConversationByProjectIdPayload {
  "projectId": string,
  "pageSize": number,
  "page": number
  "isArchived": boolean,
  "withLastUserMessage"?: boolean
}

export interface ConvertedProjectResponse {
  id: string;
  name: string;
  tenantId: string;
  createdAt: string;  
  createdBy: string;
  updatedAt: string; 
  prompts?: any[];
}

export interface ProjectResponse {
 data: ConvertedProjectResponse[],
 page: number,
 pageSize: number,
 totalCount: number
}



export interface projectQueryParams {
  page: number,
  pageSize: number,
  order?: string,
  searchQuery?: string
}

export interface fetchProjectFilesPayload {
  projectId: string;
  page: number;
  pageSize: number;
  order?: string;
  searchQuery?: string;
  totalCount?: number;
}

export interface ProjectFileResponse {
  fileId: string;
  fileName: string;
  extension: string;
  createdAt: string;
  updatedAt: string;
  size: number;
  vectorizationStatus: string;
}

export interface ProjectFilesPaginatedResponse {
  totalCount: number;
  page: number;
  pageSize: number;
  data: ProjectFileResponse[];
}

 export type ApiConversationResponse = {
      tenantId: string;
      conversationId: string;
      conversationTitle: string;
      createdBy: string;
      createdAt: string;
      isArchived: boolean;
      lastUpdatedAt: string;
      participants: object;
      messages: any[];
      events: any[];
      projectId: string | null;
      shareMetadata?: { token: string; permissionType: string; createdBy: string; createdAt: string; expiresAt: string | null }[];
      customGptId?: string;
  };
export interface CreateProjectRequest {
    name: string;
    conversationId?: string;
}

export interface CreateProjectResponse {
  id: string;
  name: string;
  tenantId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  prompts: any[];
  filesCount: number;
}


export interface UpdateProjectRequest {
   projectId?: string | null;
   conversationId: string;
   conversationTitle?: string,
   isArchived?: boolean,
}
export interface renameProjectRequest {
   projectId: string;
   name: string;
}



export const createProject = async (configurationSettings: ConfigurationSettings, payload: CreateProjectRequest): Promise<CreateProjectResponse> => {
    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjectsCreate}`;
    const response = await clients.post(url, configurationSettings.blocksKey, JSON.stringify({
      "name": payload.name,
      ...payload.conversationId && {conversationId: payload.conversationId}
    }));
    return response as CreateProjectResponse;
}

export const updateProject = async (configurationSettings: ConfigurationSettings, payload: UpdateProjectRequest) => {

  const Payload: any = { };
  payload.conversationTitle && (Payload["conversationTitle"] = payload.conversationTitle);
   "isArchived" in payload && (Payload["isArchived"] = payload.isArchived);
   "projectId" in payload && (Payload["projectId"] = payload.projectId);
   
    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.collaborationConversation}/${payload.conversationId}`;
    const response = await clients.put(url, configurationSettings.blocksKey, JSON.stringify(Payload));
    return response;
}

export const renameProject = async (configurationSettings: ConfigurationSettings, payload: renameProjectRequest) => {
    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/${payload.projectId}`;
    const response = await clients.put(url, configurationSettings.blocksKey, JSON.stringify({
  "name": payload.name
}));
    return response;
}


export const fetchProjects = async (
  queryParams: projectQueryParams,
    configurationSettings: ConfigurationSettings
  ): Promise<Project[]> => {

    const payload = {
      page: queryParams.page,
      pageSize: queryParams.pageSize,
      order: queryParams.order,
      searchQuery: queryParams.searchQuery
    }

    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}`;
    const response = await clients.post<ProjectResponse>(url, configurationSettings.blocksKey, JSON.stringify(payload));
    
    const formattedResults: Project[] = response.data.map((project: ConvertedProjectResponse) => {
 
      return {
        id: project.id,
        name: project.name,
        items: [],
      };
    });
  
    return formattedResults;
  };


  export const fetchProject = async (
    configurationSettings: ConfigurationSettings,
    projectId: string
  ): Promise<Project> => {
    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/${projectId}`;
    const response = await clients.get<ConvertedProjectResponse>(url, configurationSettings.blocksKey);
    console.log('single project',response);
    
    return {
        id: response.id,
        name: response.name,
        items: [],
        prompts: response.prompts ?? [],
    };
  };
  

export const deleteProjectById = async (configurationSettings: ConfigurationSettings, projectId: string): Promise<void> => {
    const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
    const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/${projectId}`;
    return clients.delete(url, configurationSettings.blocksKey);
}


export const getConversationByProjectId = async (
    payload: getConversationByProjectIdPayload,
    config: ConfigurationSettings
  ): Promise<{ data: ApiConversationResponse[], total_count: number }> => {

      const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
      const url = `${baseUrl}${config.paths.taskforce.collaborationConversation}`;
      return await clients.post<{ data: ApiConversationResponse[], total_count: number }>(
        `${url}`,
        config.blocksKey,
        JSON.stringify(payload)
      );
  };

  export const fetchProjectConversations = async (
  configurationSettings: ConfigurationSettings,
  projectId: string
) => {
  const res = await getConversationByProjectId(
    {
      projectId,
      pageSize: 50,
      page: 1,
      isArchived: false,
      withLastUserMessage: true,
    },
    configurationSettings
  );

  return res.data.map(conv => ({
    ProjectId: conv.projectId || '',
    ConversationId: conv.conversationId,
    ConversationTitle: conv.conversationTitle,
    CreatedBy: conv.createdBy,
    TenantId: conv.tenantId,
    CreatedDate: conv.createdAt,
    LastUpdatedDate: conv.lastUpdatedAt,
    Conversations: conv.messages,
    ShareToken: conv.shareMetadata?.[0]?.token ?? undefined,
  }));
};


export const fetchProjectFiles = async (
  configurationSettings: ConfigurationSettings,
  payload: fetchProjectFilesPayload
): Promise<ProjectFilesPaginatedResponse> => {
  const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/files`;
  
  const body: Record<string, any> = {
    projectId: payload.projectId,
    page: payload.page,
    pageSize: payload.pageSize,
  };
  
  if (payload.order) {
    body.order = payload.order;
  }
  
  if (payload.searchQuery) {
    body.searchQuery = payload.searchQuery;
  }
  
  return clients.post<ProjectFilesPaginatedResponse>(url, configurationSettings.blocksKey, JSON.stringify(body));
}

export const addFilesToProject = async (configurationSettings: ConfigurationSettings, projectId: string, file: File) => {
  const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/${projectId}/files/upload`;
  
  const formData = new FormData();
  formData.append('file', file);
  return clients.post<ProjectFileResponse>(url, configurationSettings.blocksKey, formData, {}, true);
}


export const deleteFileFromProject = async (configurationSettings: ConfigurationSettings, projectId: string, fileIds: string[]) => {
  const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/files/delete`;
  const payload = {
    projectId,
    fileIds
  };
  return clients.post(url, configurationSettings.blocksKey, JSON.stringify(payload));
}

export const addInstructionToProject = async (configurationSettings: ConfigurationSettings, projectId: string, instruction: string): Promise<ConvertedProjectResponse> => {
  const baseUrl = `https://${configurationSettings.paths.taskforceBaseUrl}`;
  const url = `${baseUrl}${configurationSettings.paths.taskforce.conversationProjects}/${projectId}/prompts`;
  const payload = {
    type: "user",
    content: instruction
  };
  return clients.post<ConvertedProjectResponse>(url, configurationSettings.blocksKey, JSON.stringify(payload));
}